(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.header__nav');
    const headerActions = document.querySelector('.header__actions.mobile');

    hamburger.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      headerActions.classList.toggle('active');
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!navMenu.contains(e.target) && !hamburger.contains(e.target)) {
        navMenu.classList.remove('active');
        headerActions.classList.remove('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-full-width-video"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', () => {
		const playButton = document.querySelector('.play-button');
		const modal = document.querySelector('.modal');
		const closeButton = document.querySelector('.close-button');
		const bgVideo = document.querySelector('.bg-video');
		const modalVideo = document.querySelector('.modal-video');

		if (playButton && modal && bgVideo && modalVideo) {
			playButton.addEventListener('click', () => {
				modal.classList.add('active');
				modalVideo.play();
				bgVideo.pause(); // Optional: pause background video
			});

			closeButton.addEventListener('click', () => {
				modal.classList.remove('active');
				modalVideo.pause();
				modalVideo.currentTime = 0; // Reset modal video
				bgVideo.play(); // Optional: resume background video
			});

			// Close modal when clicking outside
			modal.addEventListener('click', (e) => {
				if (e.target === modal) {
					modal.classList.remove('active');
					modalVideo.pause();
					modalVideo.currentTime = 0;
					bgVideo.play();
				}
			});
		}
	});

  } catch(e) { console.error(e); }
})();
})();
